/**
 * Title-case a party / person identifier: `john_doe` → `John Doe`.
 * Already-readable names (`Amit Sterling`, `COSCO`, `IL Consignee Ltd`)
 * are left as authored.
 */
export function formatPersonName(name: string | null | undefined): string {
  if (!name?.trim()) return "—";
  const trimmed = name.trim();
  if (!trimmed.includes("_") && /\s/.test(trimmed)) return trimmed;
  if (!/[_-]/.test(trimmed) && /[A-Z]/.test(trimmed)) return trimmed;
  return trimmed
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((segment) =>
      segment
        .split("-")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join("-"),
    )
    .join(" ");
}
